export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export type ADD_NOTIFICATION = typeof ADD_NOTIFICATION;

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export type REMOVE_NOTIFICATION = typeof REMOVE_NOTIFICATION;
